<template>
  <Print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 안전보건총괄책임자 정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 안전보건총괄책임자 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.성명 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.성명" />
        </div>
        <div>
          <div>소속명</div>
          <span v-if="isPrint" class="print-input"> {{ form.소속명 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.소속명" />
        </div>
        <div>
          <div>직책</div>
          <span v-if="isPrint" class="print-input"> {{ form.직책 }} </span>
          <ml-input v-else :readonly="board.readonly" v-model="form.직책" />
        </div>
        <div>
          <div>선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.선임일 }} </span>
          <DateSelector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.선임일" />
        </div>
      </div>
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import Print from "./Print";

export default {
  components: {
    FieldSelectModule,
    DateSelector,
    FileUploadModule,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        성명: "",
        소속명: "",
        직책: "",
        선임일: "",

        fileList: [],
        companyName: "",
      },
    };
  },
  created() {
    if (this.value) {
      const keys = Object.keys(this.value);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }
    }
  },
};
</script>
